import { useEffect, useState } from "react";
import { setCookie } from "cookies-next";
import type { ICore } from "@kunduz/data-access-core-api";
import { SiteLangEnum } from "@kunduz/utility-common";

/**
 * when there is a user info, set users country as lang
 * @param extendedMe
 * @returns
 */

// TODO buraya artık sadece öğrenci gelmeyecek

export function useUserLanguage(extendedMe: ICore.IStudentV4 | undefined) {
  const [userLang, setUserLang] = useState<SiteLangEnum | undefined>(undefined);

  useEffect(() => {
    if (!extendedMe) return;

    const lang =
      `${extendedMe.country.language}-${extendedMe.country.iso_code}` as SiteLangEnum; // extendedMe.country.code == 90 ? "tr" : "en";

    setCookie("kz_user_lang", lang, {
      path: "/",
      expires: new Date(new Date().setFullYear(new Date().getFullYear() + 10)),
      sameSite: "lax",
      domain: process.env["NEXT_PUBLIC_COOKIE_DOMAIN"],
    });

    setUserLang(lang);
  }, [extendedMe]);

  function setUserLanguage(lang: SiteLangEnum) {
    setCookie("kz_user_lang", lang, {
      path: "/",
      expires: new Date(new Date().setFullYear(new Date().getFullYear() + 10)),
      sameSite: "lax",
      domain: process.env["NEXT_PUBLIC_COOKIE_DOMAIN"],
    });

    setUserLang(lang);
  }

  return { userLang, setUserLanguage };
}
